import React, { useState, useEffect } from "react";

import { K_COLORS_DARK_GREY, K_COLORS_LIGHT_BLUE } from "constants.js";

const Loader = () => {
  const [counter, setCounter] = useState(0);
  const dots = [];

  useEffect(() => {
    setTimeout(() => {
      setCounter((counter + 1) % 2);
    }, 250);
  }, [counter]);

  for (let i = 0; i < 3; i++) {
    const colorStyle = i % 2 === counter ? styles.primary : styles.secondary;
    dots.push(
      <div style={styles.circleContainer} key={i}>
        <div style={{ ...styles.circle, ...colorStyle }} />
      </div>,
    );
  }

  return <div style={styles.container}>{dots}</div>;
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "5rem",
  },
  circleContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "1.5rem",
    marginRight: "0.1rem",
    marginLeft: "0.1rem",
  },
  circle: {
    borderRadius: "100%",
    transition: "0.25s",
    transitionTimingFunction: "ease-out",
  },
  primary: {
    width: "1rem",
    height: "1rem",
    backgroundColor: K_COLORS_LIGHT_BLUE,
  },
  secondary: {
    width: "0.75rem",
    height: "0.75rem",
    backgroundColor: K_COLORS_DARK_GREY,
  },
};

export default Loader;
